/** 个人名片信息，存于 pages 表（slug = profile-card，JSON 格式）。这里是默认值。 */
export interface ProfileContent {
  name: string;
  bio: string;
  /** 头像 URL，留空则显示首字母占位头像 */
  avatar_url: string;
  github: string;
  email: string;
  /** 个人网站，留空则不显示 */
  website: string;
}

export const defaultProfile: ProfileContent = {
  name: 'zhaoxi',
  bio: '全栈工程师，关注 Rust 与云原生',
  avatar_url: '',
  github: 'https://github.com/zhaoxi',
  email: 'hi@example.com',
  website: '',
};

/** 解析 DB 里的 JSON，缺字段或解析失败时回落到默认值 */
export function parseProfile(contentMd?: string): ProfileContent {
  if (!contentMd) return defaultProfile;
  try {
    return { ...defaultProfile, ...JSON.parse(contentMd) };
  } catch {
    return defaultProfile;
  }
}
